import { render, staticRenderFns } from "./TableTransferGudang.vue?vue&type=template&id=498b27e0"
import script from "./TableTransferGudang.vue?vue&type=script&lang=js"
export * from "./TableTransferGudang.vue?vue&type=script&lang=js"
import style0 from "./TableTransferGudang.vue?vue&type=style&index=0&id=498b27e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports